/*! ch-storefront-bust — redirect stale cached homepage to fresh render */
(function () {
  try {
    if (window.__CH_BUST__) return;
    window.__CH_BUST__ = 1;
    var dark = document.querySelector('.ch-hero--split');
    var bright = document.querySelector('.chc-hero');
    if (dark && !bright && location.pathname === '/' && !/[?&](view=|chc=1)/.test(location.search)) {
      location.replace('/?view=' + (location.hash || ''));
    }
  } catch (e) {}
})();
